<mat-card class="mappedservo-card">

  <mat-card-header>
    <div mat-card-avatar class="mappedservo-header-image"><mat-icon aria-hidden="false" aria-label="home icon">device_hub</mat-icon></div>

    <mat-card-title> Ref {{ refNumber }}   </mat-card-title>

    <mat-card-subtitle>  Slave:  <B>  {{ ioMappedServo.slaveID }}    </B>  </mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>

    <mat-grid-list cols="5" rowHeight="100px" >
      <mat-grid-tile style="background: thistle" colspan="5" rowspan="1">
        brandCode                   {{ ioMappedServo.brandCode }}             <br/>
        deviceCreated               {{ ioMappedServo.deviceCreated }}         <br/>
        deviceInUse                 {{ ioMappedServo.deviceInUse }}           <br/>
        nodePresentFlag             {{ ioMappedServo.nodePresentFlag }}       <br/>
      </mat-grid-tile>

      <mat-grid-tile style="background: lavender" colspan="5" rowspan="1">
        alarmFlag                   {{ ioMappedServo.alarmFlag }}               <br/>
        Node errorCode                   {{ ioMappedServo.errorCode }}               <br/>
      </mat-grid-tile>

      <mat-grid-tile style="background: cornflowerblue" colspan="5" rowspan="1">
        actualPower                 {{ ioMappedServo.actualPower }}           <br/>
        actualValue                 {{ ioMappedServo.actualValue }}           <br/>
        actualBackwardFlag          {{ ioMappedServo.actualBackwardFlag  }}   <br/>
        freqValue                   {{ ioMappedServo.freqValue }}             <br/>
        powerActiveFlag             {{ ioMappedServo.powerActiveFlag }}       <br/>
      </mat-grid-tile>

      <mat-grid-tile style="background: ivory" colspan="5" rowspan="1">
        requestRunBackwardFlag        {{ ioMappedServo.requestRunBackwardFlag }}        <br/>
        requestValue                {{ ioMappedServo.requestValue }}                    <br/>
        enabledFlag                 {{ ioMappedServo.enabledFlag }}                     <br/>
      </mat-grid-tile>


<!--      <mat-grid-tile style="background: lavender" colspan="5" rowspan="3">-->
<!--        actualBackwardFlag          {{ ioMappedServo.actualBackwardFlag  }}                     <br/>-->
<!--        actualPower                 {{ ioMappedServo.actualPower }}                     <br/>-->
<!--        actualValue                 {{ ioMappedServo.actualValue }}                     <br/>-->
<!--        alarmFlag                   {{ ioMappedServo.alarmFlag }}                     <br/>-->
<!--        brandCode                   {{ ioMappedServo.brandCode }}                     <br/>-->
<!--        deviceCreated               {{ ioMappedServo.deviceCreated }}                     <br/>-->
<!--        deviceInUse                 {{ ioMappedServo.deviceInUse }}                     <br/>-->
<!--        enabledFlag                 {{ ioMappedServo.enabledFlag }}                     <br/>-->
<!--        errorCode                   {{ ioMappedServo.errorCode }}                     <br/>-->
<!--        freqValue                   {{ ioMappedServo.freqValue }}                     <br/>-->
<!--        nodePresentFlag             {{ ioMappedServo.nodePresentFlag }}                     <br/>-->
<!--        powerActiveFlag             {{ ioMappedServo.powerActiveFlag }}                     <br/>-->
<!--        requestRunBackwardFlag        {{ ioMappedServo.requestRunBackwardFlag }}                     <br/>-->
<!--        requestValue                {{ ioMappedServo.requestValue }}                     <br/>-->
<!--        slaveID                     {{ ioMappedServo.slaveID }}                     <br/>-->

<!--      </mat-grid-tile>-->

    </mat-grid-list>


    <p>



  </mat-card-content>
<!--  <mat-card-actions>-->
<!--    <button mat-button>LIKE</button>-->
<!--    <button mat-button>SHARE</button>-->
<!--  </mat-card-actions>-->
</mat-card>





